import { Component } from '@angular/core';
import { PaypalAccount } from './paypal-account.model';
import { RouterConst } from '../../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { ClientsService } from '../../../../services/clients/clients.service';
import { Globals } from '../../../../globals/Globals';
import { SuperClass } from '../../../../superclass/SuperClass';
import { WsService } from '../../../../services/websocket/WsService';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-analytics-paypal-accounts',
  templateUrl: './paypal-accounts.component.html',
  styleUrls: ['./paypal-accounts.component.css'],
})
export class AnalyticsPaypalAccountsComponent extends SuperClass {
  selectedRow: PaypalAccount;
  newAccount: PaypalAccount;
  newAccountForm: FormGroup;
  selectedRowForm: FormGroup;

  display = false;
  accounts: PaypalAccount[];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Accounts' },
      {
        label: 'Paypal Accounts',
        routerLink: [
          { outlets: { sub: [RouterConst.ANALYTICS_PAYPAL_ACCOUNTS] } },
        ],
      },
    ]);
    this.newAccount = new PaypalAccount();
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  reloadData() {
    this.http_getAllAccounts('paypal', (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.accounts = data.payload;
      }
    });

    this.selectedRowForm = this.fb.group({
      name: new FormControl('', Validators.required),
      appId: new FormControl('', Validators.required),
      secret: new FormControl('', Validators.required),
    });

    this.newAccountForm = this.fb.group({
      name: new FormControl('', Validators.required),
      appId: new FormControl('', Validators.required),
      secret: new FormControl('', Validators.required),
    });
  }

  selectRow(e) {
    this.selectedRow = new PaypalAccount(e.data);
  }

  saveAccount() {
    const requiredFields = [
      { id: 'name', value: this.selectedRow.name, fieldName: 'Name' },
      {
        id: 'appId',
        value: this.selectedRow.paypalClientId,
        fieldName: 'Client Id',
      },
      {
        id: 'secret',
        value: this.selectedRow.paypalClientSecret,
        fieldName: 'Secret',
      },
    ];
    if (this.hasEmptyFields(requiredFields)) {
      return;
    }

    this.http_updateAccounts(this.selectedRow, 'paypal', (data: any) => {
      this.showSuccessMessage('Account has been updated');
      this.unselectRow();
      this.accounts = data.payload;
    });
  }

  addNewAccount() {
    this.display = true;
    this.newAccount = new PaypalAccount();
  }

  createNewAccount() {
    const requiredFields = [
      { id: 'new_name', value: this.newAccount.name, fieldName: 'Name' },
      {
        id: 'new_clientId',
        value: this.newAccount.paypalClientId,
        fieldName: 'Client Id',
      },
      {
        id: 'new_secret',
        value: this.newAccount.paypalClientSecret,
        fieldName: 'Secre',
      },
    ];
    if (this.hasEmptyFields(requiredFields)) {
      return;
    }

    this.http_addAccount(this.newAccount, 'paypal', (data: any) => {
      this.showSuccessMessage('Account has been created');
      this.unselectRow();
      this.accounts = data.payload;
    });
    this.display = false;
  }

  deleteAccount() {
    this.http_deleteAccount(this.selectedRow, 'paypal', (data: any) => {
      this.showSuccessMessage('Account has been deleted');
      this.unselectRow();
      this.accounts = data.payload;
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/paypal-accounts/paypal-accounts.component.ts